import { Menu, MenuItem } from "@mui/material";
import { MuiBox, MuiTypography } from "components/atoms";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { openAdminModal } from "store/slices/common/adminModal.slice";
import { Button } from "components/ui";
import { EllipsisVertical, Pencil, Trash } from "lucide-react";

import DeleteIconSVGModel from "assets/images/deleteIconSVGModel.svg";
import {
  DeleteReportReasonAction,
} from "store/middlewares/dataManagement/reportReason";
import checkAccess from "utils/checkAccess";
import ModalEditReportReason from "components/molecules/DataManagement/ModalEditReportReason";

const ReportReason = ({ row, onActionComplete }) => { // Replace filter with onActionComplete
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(
      openAdminModal({
        title: "Edit Reason",
        content: (
          <ModalEditReportReason 
            row={row} 
            onSuccess={onActionComplete} // Pass onActionComplete to modal
          />
        ),
      })
    );
  };

  const handleDelete = () => {
    Swal.fire({
      title: `Are you sure you want to delete this reason?`,
      imageUrl: DeleteIconSVGModel,
      imageWidth: 100,
      imageHeight: 100,
      showCancelButton: true,
      confirmButtonText: "Confirm",
      customClass: {
        popup: "custom-swal-popup",
        title: "Swal-title-class",
        confirmButton: "custom-swal-confirm",
        cancelButton: "custom-swal-cancel",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          DeleteReportReasonAction({ 
            id: row.id, 
            onSuccess: () => {
              if (onActionComplete) {
                // Use setTimeout to ensure this runs after delete completes
                setTimeout(() => {
                  onActionComplete();
                }, 100);
              }
              Swal.fire({
                title: "Deleted!",
                text: "Report reason has been deleted successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false
              });
            }
          })
        );
      }
    });
  };

  //--------------------------------------------------- Action Menu Array --------------------------------------
  const ActionMenuArray = [
    checkAccess("update_chat_report_reason") && {
      label: "Edit",
      icon: <Pencil size={16} color="#475569" />,
      onClick: handleEdit, // Use handleEdit function
    },
    checkAccess("delete_chat_report_reason") &&
      !row.is_default && {
        label: "Delete",
        icon: <Trash size={16} color="#475569" />,
        onClick: handleDelete, // Use handleDelete function
      },
  ].filter(Boolean);

  // For action menu
  const [actionMenu, setActionMenu] = useState(null);
  const handleActionMenuOpen = (event) => {
    setActionMenu(event.currentTarget);
  };
  const handleActionMenuClose = () => {
    setActionMenu(null);
  };

  return (
    <MuiBox className="flex h-full items-center justify-center gap-3">
      <Button
        className="size-7"
        mode="icon"
        variant="ghost"
        onClick={handleActionMenuOpen}
      >
        <EllipsisVertical />
      </Button>
      <Menu
        anchorEl={actionMenu}
        open={Boolean(actionMenu)}
        onClose={() => handleActionMenuClose(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        sx={{
          " & .MuiMenu-paper": {
            mt: "10px",
            background: "#fff",
            boxShadow:
              "0 4px 6px -1px #e2e8f0, 0 2px 4px -2px #e2e8f0 !important",
          },
        }}
      >
        {ActionMenuArray.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => {
              handleActionMenuClose();
              option.onClick();
            }}
          >
            <MuiBox sx={{ display: "flex", alignItems: "center", gap: "9px" }}>
              <MuiBox sx={{ width: "fit-content" }}>{option.icon}</MuiBox>
              <MuiTypography
                sx={{ fontWeight: "500", fontSize: "13px", color: "#475569" }}
              >
                {option.label}
              </MuiTypography>
            </MuiBox>
          </MenuItem>
        ))}
      </Menu>
    </MuiBox>
  );
};

export default ReportReason;